import { forwardRef, type Ref, type SVGProps } from "react";
const IconGymOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M3.978 18.121a1 1 0 0 0 0 1.414L6.1 21.657a1 1 0 0 0 0 1.414l2.828 2.828a1 1 0 0 0 1.414 0l2.122 2.122a1 1 0 0 0 1.414 0l1.414-1.415a1 1 0 0 0 0-1.414l-2.121-2.121a1 1 0 0 0 0-1.414l-.707-.707 8.485-8.485.707.707a1 1 0 0 0 1.414 0l-1.414-1.415 3.536 3.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.415l-2.12-2.121a1 1 0 0 0 0-1.414L23.07 6.1a1 1 0 0 0-1.414 0l-2.121-2.12a1 1 0 0 0-1.414-.001l-1.414 1.414a1 1 0 0 0 0 1.414l3.535 3.536-1.414-1.414a1 1 0 0 0 0 1.414l.707.707-8.485 8.486-.708-.708a1 1 0 0 0-1.414 0l-2.121-2.121a1 1 0 0 0-1.414 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconGymOutlineSVG);
ForwardRef.displayName = "IconGymOutline";
export { ForwardRef as IconGymOutline };
